<template>
  <div class="drawer-iframe" :style="customerStyle">
    <div class="drawer-header">
      <div class="drawer-title">
        <span class="title">{{ headerTitle }}</span>
        <el-link :href="url" type="primary" target="_blank">
          新窗口打开
        </el-link>
      </div>
      <i class="el-icon-close close-icon" @click="close"></i>
    </div>

    <div class="drawer-content">
      <div v-if="expandable" class="v-flex-center v-pl-5 v-pr-5">
        <el-button class="btn" type="text" @click="onCollapse">
          收起
          <i class="el-icon-d-arrow-right" />
        </el-button>
      </div>

      <iframe
        v-if="iframeSrc || url"
        :src="iframeSrc || url"
        frameborder="0"
        sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-scripts allow-same-origin allow-popups-to-escape-sandbox"
        ref="iframe"
        :id="new Date().valueOf()"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DrawerIframe',
  props: {
    url: String,
    title: String,
    iframeSrc: String,
    expandable: Boolean,
    customerStyle: String
  },
  data() {
    return {
      href: null,
      headerTitle: this.$parent?.title || this.title || '详情',
      expanded: true
    }
  },
  methods: {
    close() {
      this.$parent?.hide?.()
    },

    onCollapse() {
      this.$emit('collapse')
    }
  }
  // mounted() {
  //   reset({ globalBtn: { show: false } })
  // },
  // beforeDestroy() {
  //   reset({ globalBtn: { show: true } })
  // }
}
</script>
<style lang="stylus" scoped>
.drawer-iframe{
  width: 100%
  min-width: 600px;
  height: 100%
  overflow: auto;
  .drawer-header{
    width: 100%
    padding: 0 20px;
    color: #72767b;
    display: flex;
    align-items center
    justify-content space-between
    height 50px
    border-bottom 1px solid $--border-color-base
  }
  .drawer-content{
    width: 100%;
    height: calc(100% - 50px);

    display: flex;
    .btn{
      display: block;
      // position: absolute;
      // left: 0;
      // top: 50%;
    }
  }
  .drawer-title{
    flex: 1
    display: flex;
    align-items center
    justify-content space-between
    margin-right 20px
  }
  .close-icon, .title{
    font-size 18px;
    font-weight: 500;
    color: #141414;
    cursor: pointer
  }
  .drawer-content iframe{
    width 100%;
    height: 100%;
    // height: calc(100% - 50px)
  }
}
</style>
